import { render } from "./inventory-dashboard.vue?vue&type=template&id=3b7351f8&scoped=true"
import script from "./inventory-dashboard.vue?vue&type=script&lang=js"
export * from "./inventory-dashboard.vue?vue&type=script&lang=js"

import "./inventory-dashboard.vue?vue&type=style&index=0&id=3b7351f8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7351f8"]])

export default __exports__